import api from '../utils/httpClient';

export const getAccountDevicesPromise = async (accountId: string) => {
  const { data } =  await api.get(`/account/${accountId}/devices`);
  return data
}
